<script>
import { defineAsyncComponent } from 'vue';
import "@common/syncfusionCss";
import { Query } from "@syncfusion/ej2-data/src/query";
import { componentStore } from "@common/componentStore/componentStore";
import { ddStore } from "@common/ddStore";
import { library } from "@common/library/library";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const editorSettings = {};

let addHoursCfg = {
    cId: "addHours",
    cType: "addHours",
    cTitle: "Add Hours",
    cTemplate: `<div class="quick-add">
                    <label v-if="psp === 1">{{ddStoreFilter('DD.LOGBOOK.LOGBOOK_QUICK_ADD_CTRL_OPP')}}</label>
                    <label v-else>{{ddStoreFilter('DD.LOGBOOK.LOGBOOK_QUICK_ADD_CTRL_VOL')}}</label>
                    <br><br>
                    <control v-if="psp === 1" name="DISPLAY_ONLY_PLACED"></control>

                    <control v-if="psp === 1" name="OPP_LIST" :items="listItems"></control>
                    <control v-else name="VOL_LIST" :items="listItems"></control>

                    <control v-if="psp === 1 && !controlValue('DISPLAY_ONLY_PLACED')" name="QUICK_VOL_PLACE"></control>
                    <control v-if="psp === 1 && notPlacedList.length" name="SHOW_LIST_OFF_NOT_PLACED"></control>
                    <div class="quick-add-times">
                        <control name="START_TIME" :placeholder="dispTimeFormat"></control>
                        <control name="END_TIME" :placeholder="dispTimeFormat"></control>
                        <control name="HOURS" :placeholder="dispTimeFormat"></control>
                    </div>
                    <control name="START_DATE"></control>
                    <div class="quick-add-save">
                        <control name="CREATE_ANOTHER"></control>
                        <control name="SAVE"></control>
                    </div>
                </div>
                `,
    controls: [
        {
            name: 'DISPLAY_ONLY_PLACED',
            type: 'checkbox',
            label: 'DD.LOGBOOK.LOGBOOK_QUICK_ADD_CTRL_DISP_ONLY_PL_OPP',
            onchange: 'displayOnlyPlacedChanged',
            default: true
        },
        {
            name: 'OPP_LIST',
            type: 'dropdown',
            fields: { text: 'text', value: 'value' },
            popupHeight: "220px",
            allowFiltering: true,
            onfiltering: "listFiltering",
            onchange: "oppListChanged"
        },
        {
            name: 'VOL_LIST',
            type: 'multiselect',
            fields: { text: 'text', value: 'value' },
            popupHeight: "220px",
            allowFiltering: true
        },
        {
            name: 'QUICK_VOL_PLACE',
            type: 'radio_button_list',
            label: 'DD.LOGBOOK.LOGBOOK_IF_VOLUNTEER_NOT_PLACED',
            items: [
                { label: 'DD.LOGBOOK.LOGBOOK_IF_VOLUNTEER_NOT_PLACED_PLACE', value: true },
                { label: 'DD.LOGBOOK.LOGBOOK_IF_VOLUNTEER_NOT_PLACED_SKIP', value: false },
            ],
            default: false
        },
        {
            name: 'SHOW_LIST_OFF_NOT_PLACED',
            type: 'button',
            label: 'DD.LOGBOOK.LOGBOOK_QUICK_ADD_CTRL_SHOW_NON_PL_VOLS',
            onclick: 'showNonPlacedList'
        },
        {
            name: 'START_TIME',
            type: 'string',
            label: 'DD.LOGBOOK.LOGBOOK_QUICK_ADD_CTRL_START_TIME',
            onchange: 'processTime'
        },
        {
            name: 'END_TIME',
            type: 'string',
            label: 'DD.LOGBOOK.LOGBOOK_QUICK_ADD_CTRL_END_TIME',
            onchange: 'processTime'
        },
        {
            name: 'HOURS',
            type: 'string',
            label: 'DD.LOGBOOK.LOGBOOK_QUICK_ADD_CTRL_HOURS',
            onchange: 'processTime'
        },
        {
            name: 'START_DATE',
            type: 'date',
            isCalendar: true,
            default: new Date()
        },
        {
            name: 'CREATE_ANOTHER',
            type: 'checkbox',
            label: 'DD.LOGBOOK.LOGBOOK_QUICK_ADD_CTRL_CREATE_ANOTHER',
        },
        {
            name: 'SAVE',
            type: 'button',
            label: 'DD.LOGBOOK.LOGBOOK_QUICK_ADD_CTRL_SAVE_BTN',
            onclick: 'addHours'
        },
    ]
};

const addHoursCmp = {
    name: 'addHours',
    preInitControls: true,
    editorSettings: editorSettings,
    props: {
        recordIDs: {
            type: Object,
            default: []
        },
        psp: {
            default: 1
        }
    },
    data() {
        return {
            listItems: [],
            listFilteringTimeout: false,
            notPlacedList: [],
            notPlacedPopUpParams: {},
            dispTimeFormat: "hh:mm",
            hoursFormat: "HH:mm",

        };
    },
    computed: {
        timeFormats() {
            return library.getTimeFormats();
        },
        dateFormats() {
            return library.getDateFormats();
        },
        dateFormat() {
            return library.getJsFormat(this.accountSettings['ACCOUNT_DATE_FORMAT'], true);
        },
        timeFormat() {
            return library.getJsFormat(this.accountSettings['ACCOUNT_TIME_FORMAT']);
        },
        lbeLimitDate() {
            return this.accountSettings['LB_LIMIT_DATE'];
        }
    },
    methods: {
        clearAll() {
            this.listItems = [];
            this.listFilteringTimeout = false;
            this.notPlacedList = [];
            this.notPlacedPopUpParams = {};
            this.controls['OPP_LIST'].value = null;
            this.controls['VOL_LIST'].value = [];
            this.controls['DISPLAY_ONLY_PLACED'].value = true;
            this.controls['QUICK_VOL_PLACE'].value = false;
            this.controls['START_TIME'].value = '';
            this.controls['END_TIME'].value = '';
            this.controls['HOURS'].value = '';
            this.controls['START_DATE'].value = new Date();
            this.controls['CREATE_ANOTHER'].value = false;
        },
        async addHours() {
            let startDate = this.controls['START_DATE'].value || false;
            let startTime = this.controls['START_TIME'].value || false;
            let placeVolunterIfUnplaced = this.controls['QUICK_VOL_PLACE'].value || false;
            let createAnother = this.controls['CREATE_ANOTHER'].value || false;
            let volIDs;
            let oppID;
            if (this.psp === 1) {
                volIDs = this.recordIDs;
                oppID = this.controls['OPP_LIST'].value || false;
            } else {
                volIDs = this.controls['VOL_LIST'].value && this.controls['VOL_LIST'].value.length ? this.controls['VOL_LIST'].value : false;
                oppID = this.recordIDs[0];
            }
            if (!volIDs.length) {
                let message = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_EMPTY_VOL_ERROR');
                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                library.showDialog(message, false, false, {
                    title: title, name: 'volNotSelected', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                return;
            }
            if (!oppID) {
                let message = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_EMPTY_OPP_ERROR');
                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                library.showDialog(message, false, false, {
                    title: title, name: 'oppNotSelected', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                return;
            }
            this.validateTime().then(async (isValid) => {
                if (isValid) {
                    let tmpStartDate = library.getMoment(startDate);
                    if (typeof lbeLimitDate === 'string' && lbeLimitDate) {
                        let lbeLimitDate = library.getMoment(this.lbeLimitDate, this.dateFormats, true);
                        if (lbeLimitDate.isValid()) {
                            if (lbeLimitDate.isAfter(tmpStartDate)) {
                                let message = "You may only report log book entries after " + this.lbeLimitDate;
                                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                                library.showDialog(message, false, false, {
                                    title: title, name: 'lbeLimitDateWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                                });
                                return;
                            }
                        }
                    }
                    startDate = tmpStartDate.format('YYYY-MM-DD');
                    let durationMinutes = 0;
                    let hours = this.controls['HOURS'].value || false;
                    if (hours) {
                        let hArr = hours.split(":");
                        let h = parseInt(hArr[0], 10);
                        let m = parseInt(hArr[1], 10);
                        durationMinutes = m + h * 60;
                    }
                    if (durationMinutes) {
                        let response = await this.sDs.post('ec_addHours', volIDs, oppID, startDate, startTime, durationMinutes, placeVolunterIfUnplaced);
                        if (response && response.status === 'success') {
                            if (createAnother) {
                                this.clearAll();
                                this.getList();
                            } else {
                                this.$emit('update:hoursAdded', true);
                            }
                        }
                    }
                }
            });
        },
        showNonPlacedList() {
            if (this.notPlacedList.length && !library.objIsEmpty(this.notPlacedPopUpParams)) {
                let notPlacedPopUpParams = library.cloneObj(this.notPlacedPopUpParams);
                notPlacedPopUpParams.headers = [];
                for (let i in notPlacedPopUpParams.columns) {
                    if (i === 'length') continue;
                    notPlacedPopUpParams.headers.push({
                        text: notPlacedPopUpParams.columns[i].drawTitle,
                        field: notPlacedPopUpParams.columns[i].COLUMN,
                        width: notPlacedPopUpParams.columns[i].DEFAULT_WIDTH,
                    });
                }
                let dialogContent = {
                    name: "import-details-popup",
                    template: '<div><grid cId="grid_add_hours_non_placed" :prop-data="gridData"></grid></div>',
                    components: {
                        grid: defineAsyncComponent(() => import('@common/grid/grid.vue'))
                    },
                    data() {
                        return {
                            gridData: notPlacedPopUpParams
                        };
                    }
                };
                library.showDialog(dialogContent, false, false, {
                    title: this.notPlacedPopUpParams.title, name: 'nonPlacedVolunteers', width: '800px', preventCloseOnBackdropClick: true, showAsAlert: true
                });
            }
        },
        displayOnlyPlacedChanged() {
            this.listItems = [];
            this.notPlacedList = [];
            this.getList();
        },
        async oppListChanged(event) {
            this.notPlacedList = [];
            if (event.value && parseInt(event.value, 10) > 0 && this.psp === 1) {
                let response = await this.sDs.post('ec_addHoursGetNotPlacedVolunteers', this.recordIDs, event.value);
                if (response && response.status === 'success') {
                    this.notPlacedPopUpParams = library.cloneObj(response.data);
                    this.notPlacedList = library.cloneObj(response.data.records);
                }
            }
        },
        async listFiltering(event) {
            if (this.listFilteringTimeout) {
                clearTimeout(this.listFilteringTimeout);
            }
            this.listFilteringTimeout = setTimeout(async () => {
                await this.getList(event.text);
                let searchData = this.listItems;
                let query = new Query();
                query = (event.text !== "") ? query.where("text", "contains", event.text, true) : query;
                event.updateData(searchData, query);
            }, 1000);
        },
        async getList(searchString) {
            if (!this.recordIDs.length) return [];
            let tmpList = library.cloneObj(this.listItems);
            if (!searchString) searchString = '';
            let placedOnly = this.controls['DISPLAY_ONLY_PLACED'].value || false;
            let response = false;
            if (this.psp === 1) {
                response = await this.sDs.post('ec_addHoursGetOppList', this.recordIDs, placedOnly, searchString);
            } else {
                response = await this.sDs.post('ec_addHoursGetVolList', this.recordIDs[0], searchString);
            }

            if (response && response.status === 'success') {
                for (let i in response.data) {
                    if (i === 'length') continue;
                    let someFnc = (element) => element.value === i;
                    if (!tmpList.some(someFnc)) {
                        tmpList.push({
                            text: response.data[i],
                            value: i
                        });
                    }
                }
            }
            this.listItems = library.cloneObj(tmpList);
            return this.listItems;
        },
        async onLoad() {
            this.clearAll();
            ddStore.preloadGroup('LOGBOOK');
            this.getList();
        },
        async processTime(event, tmpObjId) {
            if (event && !event.isInteraction) return false;
            let objId;
            if (event
                && event.event
                && event.event.target
                && event.event.target.attributes
                && event.event.target.attributes.realid
                && event.event.target.attributes.realid.value) {
                objId = event.event.target.attributes.realid.value;
            } else if (tmpObjId) {
                objId = tmpObjId;
            }
            if (!objId) return false;
            let startTime = this.controls['START_TIME'].value || false;
            let endTime = this.controls['END_TIME'].value || false;
            let hours = this.controls['HOURS'].value || false;

            if (!startTime) {
                return false;
            }
            startTime = library.getMoment(startTime, this.timeFormats, true);
            if (!startTime.isValid()) {
                let startTimeLabel = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_CTRL_START_TIME');
                let message = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_TIME_FORMAT_ERROR', startTimeLabel, this.dispTimeFormat);
                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                library.showDialog(message, false, false, {
                    title: title, name: 'startTimeWrongFormat', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                return false;
            }
            this.controls['START_TIME'].value = startTime.format(this.timeFormat);

            if (hours && objId === "HOURS") {
                let re = /^((0[0-9]?)|[1-9]\d*)(:[0-5]\d{1})?$/;
                if (!re.test(hours)) {
                    let startTimeLabel = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_CTRL_HOURS');
                    let message = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_HOURS_FORMAT_ERROR', startTimeLabel, this.dispTimeFormat);
                    let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                    library.showDialog(message, false, false, {
                        title: title, name: 'hoursWrongFormat', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                    return false;
                }
                let hArr = hours.split(":");
                let h = parseInt(hArr[0], 10);
                let m = parseInt(hArr[1], 10);

                if (startTime) {
                    let endTime = startTime.clone();
                    endTime.add(h, "h").add(m, "m");
                    this.controls['END_TIME'].value = endTime.format(this.timeFormat);
                }
            } else if (endTime && objId === "END_TIME") {
                endTime = library.getMoment(endTime, this.timeFormats, true);
                if (!endTime.isValid()) {
                    let startTimeLabel = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_CTRL_END_TIME');
                    let message = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_TIME_FORMAT_ERROR', startTimeLabel, this.dispTimeFormat);
                    let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                    library.showDialog(message, false, false, {
                        title: title, name: 'endTimeWrongFormat', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                    return false;
                }
                let duration = library.getMomentObj().duration(endTime.diff(startTime));
                let diff = library.getMomentObj().utc(duration.asMilliseconds()).format(this.hoursFormat);

                this.controls['HOURS'].value = diff;
                this.controls['END_TIME'].value = endTime.format(this.timeFormat);
            } else if (hours && objId === "START_TIME") {
                this.processTime(false, 'HOURS');
            } else if (endTime && objId === "START_TIME") {
                this.processTime(false, 'END_TIME');
            }
            return true;
        },
        async validateTime() {
            let startTime = this.controls['START_TIME'].value;
            let endTime = this.controls['END_TIME'].value;

            if (!startTime) {
                let startTimeLabel = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_CTRL_START_TIME');
                let message = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_EMPTY_TIME_ERROR', startTimeLabel);
                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                library.showDialog(message, false, false, {
                    title: title, name: 'startTimeEmpty', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                return false;
            }
            startTime = library.getMoment(startTime, this.timeFormats, true);
            if (!startTime.isValid()) {
                let startTimeLabel = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_CTRL_START_TIME');
                let message = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_TIME_FORMAT_ERROR', startTimeLabel, this.dispTimeFormat);
                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                library.showDialog(message, false, false, {
                    title: title, name: 'startTimeWrongFormat', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                return false;
            }
            if (!endTime) {
                let startTimeLabel = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_CTRL_END_TIME');
                let message = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_EMPTY_TIME_ERROR', startTimeLabel);
                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                library.showDialog(message, false, false, {
                    title: title, name: 'endTimeEmpty', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                return false;
            }
            endTime = library.getMoment(endTime, this.timeFormats, true);
            if (!endTime.isValid()) {
                let startTimeLabel = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_CTRL_END_TIME');
                let message = await ddStore.getAlias('LOGBOOK', 'LOGBOOK_QUICK_ADD_TIME_FORMAT_ERROR', startTimeLabel, this.dispTimeFormat);
                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                library.showDialog(message, false, false, {
                    title: title, name: 'endTimeWrongFormat', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                return false;
            }
            return true;
        }
    }
};

componentStore.initComponent(addHoursCmp, addHoursCfg);
export { addHoursCfg, addHoursCmp };
export default addHoursCmp;
</script>

<style lang="css">
@import "~@common/global.css";
@import "~@assets/css/utilities.css";
@import "~@assets/css/fonts.css";
</style>

<style scoped>
.quick-add {
    width: 350px;
}

:deep(.quick-add) {
    font-size: 13px !important;
}

:deep(.quick-add label) {
    font-size: 13px !important;
}

:deep(.checkbox-list-input) {
    margin: 0;
}

:deep(.checkboxes-container) {
    margin: 0;
}

:deep([for=CREATE_ANOTHER_addHours]) {
    margin-top: 5px;
}

.quick-add-times, .quick-add-save {
    display: flex;
}

.quick-add-times > div {
    flex-grow: 3;
    margin-right: 10px;
}

.quick-add-times > div:last-child {
    margin-right: 0px;
}

.quick-add-save {
    margin-top: 10px;
}

.quick-add-save > div {
    flex-grow: 5;
}
</style>
